import { render } from "./PoliticasPrivacidades.vue?vue&type=template&id=6f2d95d1&scoped=true"
import script from "./PoliticasPrivacidades.vue?vue&type=script&lang=js"
export * from "./PoliticasPrivacidades.vue?vue&type=script&lang=js"

import "./PoliticasPrivacidades.vue?vue&type=style&index=0&id=6f2d95d1&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2d95d1"]])

export default __exports__